exports.productParams = {
  // urlPrefix: "/sacs-en-tissu/",
  urlPrefix: "/",
};

exports.productUrl = (product) => {
  return `${this.productParams.urlPrefix}${
    product.categories.length ? product.categories[0].slug + "/" : ""
  }${product.slug}/`;
};

exports.createProducts = async ({ graphql, actions }) => {
  const { createPage, createRedirect } = actions;
  const result = await graphql(
    `
      {
        products: allStrapiProduct(filter: { status: { eq: "published" } }) {
          edges {
            node {
              slug
              status
              categories {
                id
                slug
              }
            }
          }
        }
      }
    `
  );

  if (result.errors) {
    throw result.errors;
  }

  const products = result.data.products.edges;
  const ProductTemplate = require.resolve("./src/templates/product.js");

  products.forEach((product, index) => {
    const canonicalPath = this.productUrl(product.node);

    createPage({
      path: canonicalPath,
      component: ProductTemplate,
      context: {
        ...product.node,
      },
    });

    const { categories, slug } = product.node;

    // Redirection racine : /{slug} → URL canonique catégorisée. Rattrape les
    // anciennes URLs produit à la racine (ancienne structure, toujours crawlées
    // par Google) qui tombaient en 404. Sans `force` : une vraie page à /{slug}
    // reste prioritaire (pas de collision).
    if (categories.length) {
      const rootPath = `${this.productParams.urlPrefix}${slug}`;
      if (rootPath !== canonicalPath) {
        createRedirect({
          fromPath: rootPath,
          toPath: canonicalPath,
          isPermanent: true,
          redirectInBrowser: true,
        });
      }
    }

    if (categories.length > 1) {
      categories.slice(1).forEach((category) => {
        const fromPath = `${this.productParams.urlPrefix}${category.slug}/${slug}/`;
        if (fromPath === canonicalPath) return;
        createRedirect({
          fromPath,
          toPath: canonicalPath,
          isPermanent: true,
          redirectInBrowser: true,
          force: true,
        });
      });
    }
  });
};
